import classNames from "classnames";
import { useEffect } from "react";
import GlobalWrapper from "../globalWrapper";
import styles from "./style.module.scss";
import { Icons } from "assets";

interface OptionsDropDownProps {
  id?: string;
  openSelection: boolean;
  setOpenSelection: (val: boolean) => void;
  options: OptionProps[];
  customContainer: any;
  tabIndex?: number;
  activeItem?: string;
  wrapInGlobalWrapper?: boolean;
  selectedOption?: OptionProps;
  clearSelection?: () => void;
}

const OptionsDropDown = ({
  id,
  openSelection,
  setOpenSelection,
  options,
  customContainer,
  tabIndex,
  activeItem,
  wrapInGlobalWrapper = true,
  selectedOption,
  clearSelection,
}: Partial<OptionsDropDownProps>) => {
  function handleClick(e: any) {
    const elem: any = document.getElementById(
      id ? id : "optionsDropDownContainer"
    );
    if (elem) {
      if (!elem?.contains(e.target)) {
        setOpenSelection?.(false);
      }
    }
  }

  useEffect(() => {
    document.body.addEventListener(
      "click",
      (event: any) => {
        handleClick(event);
      },
      true
    );

    return () => {
      document.body.removeEventListener(
        "click",
        (event: any) => {
          handleClick(event);
        },
        true
      );
    };
    // eslint-disable-next-line
  }, []);

  if (wrapInGlobalWrapper) {
    return openSelection ? (
      <GlobalWrapper>
        <div
          className={classNames(
            styles.optionsContainer,
            customContainer && customContainer
          )}
          id={id ? id : "optionsDropDownContainer"}
        >
          {selectedOption ? (
            <div
              className={classNames(
                "flex items-center gap-2 py-2 px-3",
                styles.selectedContainer
              )}
            >
              <label>
                Selected : <span>{selectedOption?.title}</span>
              </label>
              <Icons.Cross onClick={clearSelection} />
            </div>
          ) : null}
          {options?.map(
            (
              Item: {
                title: string;
                Icon: any;
                action: (arg: any) => any;
              },
              inx: number
            ) => {
              return (
                <div
                  className={classNames(
                    "flex items-center gap-2 py-4 px-3",
                    styles.optionContainer,
                    inx === options?.length - 1 && styles.btmradius,
                    inx === 0 && styles.topradius,
                    activeItem === Item.title && styles.activeItem
                  )}
                  style={
                    inx === options?.length - 1 ? { borderBottom: "0px" } : {}
                  }
                  onClick={() => {
                    if (tabIndex || tabIndex === 0) {
                      Item.action(tabIndex);
                    } else {
                      Item.action(Item.title);
                    }
                    setOpenSelection?.(false);
                  }}
                  key={inx}
                  role="button"
                >
                  {Item?.Icon ? (
                    <Item.Icon className={classNames(styles.iconStyle)} />
                  ) : null}
                  <label
                    className={classNames(styles.labelStyle)}
                    role="button"
                  >
                    {Item?.title}
                  </label>
                </div>
              );
            }
          )}
        </div>
      </GlobalWrapper>
    ) : null;
  } else {
    return (
      <div
        className={classNames(
          styles.optionsContainer,
          customContainer && customContainer
        )}
        id={id ? id : "optionsDropDownContainer"}
        style={
          openSelection ? { visibility: "visible" } : { visibility: "hidden" }
        }
      >
        {selectedOption ? (
          <div
            className={classNames(
              "flex items-center gap-2 py-2 px-3",
              styles.selectedContainer
            )}
          >
            <label>
              Selected : <span>{selectedOption?.title}</span>
            </label>
            <Icons.Cross onClick={clearSelection} />
          </div>
        ) : null}
        {options?.map(
          (
            Item: {
              title: string;
              Icon: any;
              action: (arg: any) => any;
            },
            inx: number
          ) => {
            return (
              <div
                className={classNames(
                  "flex items-center gap-2 py-4 px-3",
                  styles.optionContainer,
                  inx === options?.length - 1 && styles.btmradius,
                  inx === 0 && styles.topradius,
                  activeItem === Item.title && styles.activeItem
                )}
                style={
                  inx === options?.length - 1 ? { borderBottom: "0px" } : {}
                }
                onClick={() => {
                  if (tabIndex || tabIndex === 0) {
                    Item.action(tabIndex);
                  } else {
                    Item.action(Item.title);
                  }
                  setOpenSelection?.(false);
                }}
                key={inx}
                role="button"
              >
                {Item?.Icon ? (
                  <Item.Icon className={classNames(styles.iconStyle)} />
                ) : null}
                <label className={classNames(styles.labelStyle)} role="button">
                  {Item?.title}
                </label>
              </div>
            );
          }
        )}
      </div>
    );
  }
};

export default OptionsDropDown;
